import { render } from "./PaymentRequests.vue?vue&type=template&id=5532ac15&scoped=true&ts=true"
import script from "./PaymentRequests.vue?vue&type=script&lang=ts"
export * from "./PaymentRequests.vue?vue&type=script&lang=ts"

import "./PaymentRequests.vue?vue&type=style&index=0&id=5532ac15&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5532ac15"]])

export default __exports__